import React from 'react'
import { Modal, Button, Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

import * as organizationService from '../../../services/organization-service'

import { handleKeyPress } from '../../../utils'

const emailRegex = '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'

export default class AdminModal extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handlePost = this.handlePost.bind(this)

    this.state = {
      admin: this.props.admin,
      userName: undefined,
      firstName: undefined,
      prefix: undefined,
      lastName: undefined,
      email: undefined,
    }
  }

  componentDidMount() {
    const {admin} = this.state
    if (admin) {
      this.setState({
        userName: admin.userName,
        firstName: admin.firstName,
        lastName: admin.lastName,
        email: admin.email, 
        prefix: admin.prefix
      })
    }
  }

  clearForm() {
    this.setState({ 
      userName: undefined,
      firstName: undefined,
      prefix: undefined,
      lastName: undefined,
      email: undefined })
  }

  handleShow() {
    this.setState({ show: true })
  }

  handleHide() {
    this.setState({ show: false })
    if(!this.state.admin){
       this.clearForm()
    }
  }

  handlePost() {
    const {userName, firstName, lastName, prefix, email, admin} = this.state

    organizationService.upsertExtraAdmin({
      userName: userName,
      firstName: firstName, 
      lastName: lastName,
      prefix: prefix, 
      email: email,
      id: admin && admin.id
    }).then(() => { 
      this.handleHide()
      this.props.reload()
    })
  }

  validate(){
    const {userName, firstName, lastName, email} = this.state
    const isEmailValid = new RegExp(emailRegex).test(email)
    return (isEmailValid && firstName && lastName && userName )
  }

  handleChange(e) {
    const key = e.target.id
    this.setState({[key]: e.target.value})
  }

  render() {
    return (
      <div>
        <Button className={this.props.btnClassNames} onClick={this.handleShow}>
          {this.props.text}
        </Button>
        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          onKeyPress={(e) => handleKeyPress(e, this.handlePost)}
          dialogClassName="custom-modal"
          backdrop={false}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
            {this.props.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p dangerouslySetInnerHTML={{ __html: this.props.introText }}></p>
            <Form>
             <FormGroup controlId="userName">
                <ControlLabel >Gebruikersnaam *</ControlLabel>
                <FormControl onChange={this.handleChange} type="text" value={this.state.userName} />
              </FormGroup>
              <FormGroup controlId="firstName">
                <ControlLabel>Voornaam *</ControlLabel>{' '}
                <FormControl onChange={this.handleChange} type="text" value={this.state.firstName} />
              </FormGroup>
              <FormGroup controlId="prefix">
                <ControlLabel>Tussenvoegsel</ControlLabel>{' '}
                <FormControl type="text" onChange={this.handleChange} value={this.state.prefix} />
              </FormGroup>{' '}
              <FormGroup controlId="lastName">
                <ControlLabel>Achternaam *</ControlLabel>{' '}
                <FormControl type="text" onChange={this.handleChange} value={this.state.lastName} />
              </FormGroup>{' '}
              <FormGroup controlId="email">
                <ControlLabel>E-mail *</ControlLabel>{' '}
                <FormControl type="email" onChange={this.handleChange} value={this.state.email} />
              </FormGroup>{' '}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" disabled={!this.validate()} onClick={this.handlePost}>Opslaan</Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Account/components/AdminModal.js